import { useQuery } from '@tanstack/react-query';
import { formService, Form, JobFormResponseDto } from '../services/formService';
import { queryKeys } from '../config/queryKeys';

export function useForms() {
  return useQuery({
    queryKey: queryKeys.forms.list(),
    queryFn: () => formService.getForms(),
    staleTime: 5 * 60 * 1000, // Forms change rarely, 5 minute stale time
  });
}

export function useForm(id: number | undefined) {
  return useQuery({
    queryKey: queryKeys.forms.detail(id!),
    queryFn: () => formService.getForm(id!),
    enabled: !!id,
  });
}

export function useJobFormResponses(jobId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.forms.jobResponses(jobId!),
    queryFn: () => formService.getJobFormResponses(jobId!),
    enabled: !!jobId,
  });
}
